module.exports = __webpack_public_path__ + "static/media/Sanad_logo.bb873814.png";